// Evergreen Amazon Associates banner — replaces the time-bound Prime Day promo.
// Same 728 × 90 (8.09:1) slot to match the Featured Partner carousel.
export default function PrimeDayBanner({ testId = "amazon-deals-banner" }) {
  const url = "https://amzn.to/4xOUJzy";

  return (
    <section data-testid={testId} className="mt-4 sb-fade-up">
      <div className="flex items-center justify-between mb-2 px-1">
        <h2
          className="font-mono text-[10px] uppercase tracking-[0.2em]"
          style={{ color: "var(--sb-text-muted)" }}
        >
          // Amazon Deals
        </h2>
        <span className="font-mono text-[10px]" style={{ color: "var(--sb-text-muted)" }}>
          AMAZON ASSOCIATES
        </span>
      </div>

      <a
        href={url}
        target="_blank"
        rel="noopener noreferrer sponsored"
        data-testid={`${testId}-link`}
        className="group relative block rounded-lg overflow-hidden"
        style={{
          paddingTop: "12.36%",
          background:
            "linear-gradient(105deg, #131A22 0%, #232F3E 38%, #006086 68%, #FF9900 100%)",
          boxShadow:
            "inset 0 1px 0 rgba(255,255,255,0.18), 0 14px 36px -22px rgba(0,0,0,0.7)",
          border: "1px solid rgba(255,255,255,0.08)",
        }}
      >
        <div className="absolute inset-0 flex items-center justify-between px-4 sm:px-5">
          <div className="flex items-center gap-3 sm:gap-4 min-w-0">
            <div
              className="hidden sm:flex flex-col items-center justify-center px-2.5 py-1 rounded-md flex-shrink-0"
              style={{ background: "#FFFFFF" }}
            >
              <span
                className="font-display font-black text-base leading-none"
                style={{ color: "#131A22", letterSpacing: "-0.04em" }}
              >
                amazon
              </span>
              <span
                aria-hidden="true"
                style={{
                  display: "block",
                  width: "70%",
                  height: 2,
                  marginTop: 1,
                  borderRadius: 1,
                  background: "#FF9900",
                  alignSelf: "center",
                }}
              />
            </div>
            <div className="min-w-0">
              <p
                className="font-mono text-[9px] uppercase tracking-[0.18em] truncate"
                style={{ color: "rgba(255,255,255,0.85)" }}
              >
                amazon.co.uk · Today's Deals
              </p>
              <p
                className="font-display font-black text-sm sm:text-base lg:text-lg leading-tight truncate"
                style={{ color: "#FFFFFF", textShadow: "0 1px 2px rgba(0,0,0,0.4)" }}
              >
                FRESH DEALS DAILY · UP TO <span style={{ color: "#FF9900" }}>70% OFF</span>
              </p>
            </div>
          </div>

          <span
            className="font-mono text-[10px] sm:text-xs uppercase tracking-[0.16em] font-bold px-3 sm:px-4 py-1.5 sm:py-2 rounded-full inline-flex items-center gap-1 flex-shrink-0 transition-transform group-hover:scale-[1.05]"
            style={{
              background: "linear-gradient(180deg, #FFB300 0%, #FF9900 100%)",
              color: "#1A0F00",
              boxShadow:
                "inset 0 1px 0 rgba(255,255,255,0.35), 0 4px 12px -4px rgba(255,153,0,0.55)",
            }}
          >
            Shop Now <span style={{ marginLeft: 2 }}>→</span>
          </span>
        </div>
      </a>

      <p
        className="font-mono text-[9px] uppercase tracking-wider mt-1.5 px-1"
        style={{ color: "var(--sb-text-muted)" }}
      >
        As an Amazon Associate we earn from qualifying purchases.
      </p>
    </section>
  );
}
